import { MantineSize } from '@mantine/core';
import { UserAuth } from '../../../types/user';
import PublicLayout from './PublicLayout';

export default PublicLayout;

export interface PublicLayoutProps {
  children: React.ReactNode;
  withLogin?: boolean;
  titlePage?: string;
  auth?: UserAuth;
  size?: MantineSize;
}
